// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
    width: 100%;
}
.checkbox__grid {
    width: 100%;
    display: grid;
    grid-template-columns: auto 40px;
}
.checkbox__grid input { 
    justify-self: center;
    align-self: center;
}
.checkbox__label {
    text-align: left;
    padding: 5px 0;
}
.checkbox__explanation {
    font-size: 12px;
    padding: 0 0 12px 6px;
    font-style: italic;
}
.checkbox__error {
    padding: 5px;
    color: var(--danger-color-main);
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/components/ui/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,gCAAgC;AACpC;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;AACtB","sourcesContent":[".checkbox {\n    width: 100%;\n}\n.checkbox__grid {\n    width: 100%;\n    display: grid;\n    grid-template-columns: auto 40px;\n}\n.checkbox__grid input { \n    justify-self: center;\n    align-self: center;\n}\n.checkbox__label {\n    text-align: left;\n    padding: 5px 0;\n}\n.checkbox__explanation {\n    font-size: 12px;\n    padding: 0 0 12px 6px;\n    font-style: italic;\n}\n.checkbox__error {\n    padding: 5px;\n    color: var(--danger-color-main);\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
